export const fragSampler = `
precision mediump float;

uniform sampler2D uSampler0;
varying vec2 outTexCoord;

void main ()
{
  gl_FragColor = texture2D(uSampler0, outTexCoord);
}
`;
